<micro-select-combo #sel
              placeholder="Account Transaction Type"
              [mode]="mode"
              [(id)]="accountTransactionTypeId"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
>
</micro-select-combo>
